import React from 'react';

const GoogleReviews = () => {
  return (
    <section className="py-6 md:py-8 bg-white/90 backdrop-blur-md shadow-sm my-6 rounded-2xl max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-6">
        <span className="text-xs sm:text-sm font-bold text-orange-600 uppercase tracking-widest block mb-2">
          CLIENT REVIEWS &amp; RATING
        </span>
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900 mb-3">
          What Our Clients Say
        </h2>
        <p className="text-gray-600 max-w-2xl mx-auto text-sm sm:text-base">
          Verified Google reviews from PhD scholars, researchers, and clients who trust Assurance Education Group (AEG Group).
        </p>
      </div>

      {/* SociableKIT Direct Google Reviews iFrame Embed */}
      <div className="w-full overflow-hidden rounded-xl bg-white shadow-sm border border-gray-100 min-h-[660px]">
        <iframe
          src="https://widgets.sociablekit.com/google-reviews/iframe/25711885"
          frameBorder="0"
          width="100%"
          height="680"
          className="w-full h-[680px] min-h-[660px] md:min-h-[680px] rounded-xl border-0 overflow-hidden"
          title="Google Reviews - Assurance Education Group"
          loading="lazy"
          scrolling="no"
        ></iframe>
      </div>
    </section>
  );
};

export default GoogleReviews;
